/**
 * ****************************************************************************
 * @description     :   Route for chats app
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const ra000400m = () => import('@/views/ra/ra000400m');
const ra000500m = () => import('@/views/ra/ra000500m');
const ra000600m = () => import('@/views/ra/ra000600m');
const ra000700m = () => import('@/views/ra/ra000700m');
const ra000800m = () => import('@/views/ra/ra000800m');
const ra000900m = () => import('@/views/ra/ra000900m');
const ra001000m = () => import('@/views/ra/ra001000m');
const ra001100m = () => import('@/views/ra/ra001100m');
const ra001200m = () => import('@/views/ra/ra001200m');
const ra006300m = () => import('@/views/ra/ra006300m');

/**
 * Defined Router
 */
export default [
    {
        path: '/ra/ra000400m',
        name: 'ra000400m',
        component: ra000400m,
        meta: {
            title: '自社会社マスタ'
        }
    },
    {
        path: '/ra/ra000500m',
        name: 'ra000500m',
        component: ra000500m,
        meta: {
            title: '営業所マスタ'
        }
    },
    {
        path: '/ra/ra000600m',
        name: 'ra000600m',
        component: ra000600m,
        meta: {
            title: '従業員マスタ'
        }
    },
    {
        path: '/ra/ra000700m',
        name: 'ra000700m',
        component: ra000700m,
        meta: {
            title: '資格名マスタ'
        }
    },
    {
        path: '/ra/ra000800m',
        name: 'ra000800m',
        component: ra000800m,
        meta: {
            title: '職務権限マスタ'
        }
    },
    {
        path: '/ra/ra000900m',
        name: 'ra000900m',
        component: ra000900m,
        meta: {
            title: '1次会社マスタ'
        }
    },
    {
        path: '/ra/ra001000m',
        name: 'ra001000m',
        component: ra001000m,
        meta: {
            title: '作業依頼内容マスタ'
        }
    },
    {
        path: '/ra/ra001100m',
        name: 'ra001100m',
        component: ra001100m,
        meta: {
            title: 'KY項目・作業指示・基本遵守項目マスタ'
        }
    },
    {
        path: '/ra/ra001200m',
        name: 'ra001200m',
        component: ra001200m,
        meta: {
            title: '新規入場遵守事項マスタ'
        }
    },
    {
        path: '/ra/ra006300m',
        name: 'ra006300m',
        component: ra006300m,
        meta: {
            title: '組織マスタ'
        }
    }
];
